<div class="padding-2" fxLayoutAlign="center center">
    <h4>You have been logged out</h4>
</div>
